import React, { useState } from "react";
import { Form, Input, Button, Card, message } from "antd";
import { useNavigate } from "react-router-dom";
import { apiService } from "@/services/api";

export const GenreCreate: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      await apiService.createGenre({ name: values.name });
      message.success("Genre créé");
      navigate("/categories");
    } catch (e: any) {
      message.error("Erreur lors de la création du genre");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title="Créer un genre">
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item label="Nom" name="name" rules={[{ required: true }]}>
          <Input placeholder="Nom du genre" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Créer
        </Button>
      </Form>
    </Card>
  );
};

export default GenreCreate;
